export default __webpack_public_path__ + "static/media/Punto_05_Scali_Rosciano_DEU_Def.fd5b1bc5.aac";